import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import gAuth from 'vue3-google-auth';

const $gAuth = gAuth.createGAuth({
  clientId: "499062607246-plhgus5vps55kpi09jjpviv1mbt8deba.apps.googleusercontent.com",
});

const app =createApp(App);

app.config.globalProperties.$filters = {
  dateFormat(date:Date){
    let mes=(date.getMonth()+1);
    let messtr= ( (String)(mes).length==1)?"0"+mes:mes;
    return date.getFullYear()+"-"+messtr+"-"+date.getDate()+" "+date.getHours()+":"+date.getMinutes();
  },
  textoDefault(default_text:String,texto?:String){
      if (!texto){ return default_text;}
      {
	let tempo = texto.split("@");
	return tempo[0];
      }
  }
}

app.use(store).use(router).use($gAuth).mount('#app')

